import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandlerFn,
	HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
	const authService = inject(AuthService);
	const auth0Service = inject(Auth0Service);
	const isBootstrapIdentityRequest = req.url.includes(
		'/account/bootstrap-identity'
	);

	// Check if user is signed out (no token and no Auth0 auth header)
	if (
		!authService.accessToken &&
		!req.headers.has('Authorization') &&
		!isBootstrapIdentityRequest
	) {
		// No token = signed out - redirect to login and cancel the request
		auth0Service.loginWithRedirect();
		return EMPTY;
	}

	// Request
	//
	// Only add token if Auth0 interceptor didn't already add one.
	// This prevents overwriting a fresh token from Auth0 with a
	// potentially stale token from localStorage.
	if (
		!req.headers.has('Authorization') &&
		authService.accessToken
	) {
		req = AuthUtils.addBearerToken(req, authService.accessToken);
	}

	// Response
	return next(req).pipe(
		catchError((error) => {
			// Catch "401 Unauthorized" responses
			if (
				error instanceof HttpErrorResponse &&
				error.status === 401
			) {
				// Bootstrap endpoint may legitimately return 401 for users
				// without local identity claims; let caller handle UX.
				if (isBootstrapIdentityRequest) {
					return throwError(() => error);
				}

				return AuthUtils.handle401Error(
					req,
					next,
					authService,
					auth0Service
				);
			}

			return throwError(() => error);
		})
	);
};
